// i18n area 'hci' — locale uk-UA (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.uk-UA.meta.json.
import type { enUS } from './hci'

export const ukUA: typeof enUS = {
  hci: {
    ceph: {
      title: 'Кластери Ceph',
      createButton: 'Створити кластер Ceph',
      emptyTitle: 'Немає керованих кластерів Ceph',
      emptyBody: 'TVirt розгортає й тримає Ceph на вузлах-учасниках, гіперконвергентно з навантаженням ВМ. Створіть кластер: перший монітор і його менеджер народжуються автоматично на вибраному вузлі керування — потім наростіть його додатковими моніторами та пристроями OSD.',
      pageTitle: 'Кластери Ceph',
      colState: 'Стан',
      colMembers: 'Учасники',
      colSize: 'Розмір',
      colVersion: 'Версія Ceph',
      sizeCell: '{used} GiB використано з {total} GiB загалом',
      phase: {
        'not-deployed': 'Не розгорнуто',
        deploying: 'Розгортання триває',
        healthy: 'У нормі',
        degraded: 'Деградований',
        error: 'Помилка',
        destroying: 'Знищується',
        destroyed: 'Знищено'
      },
      health: {
        HEALTH_OK: 'У нормі (HEALTH_OK)',
        HEALTH_WARN: 'З попередженнями (HEALTH_WARN)',
        HEALTH_ERR: 'З помилками (HEALTH_ERR)',
        unknown: 'Ще не спостерігалася',
        observedAt: 'спостережено {time}'
      },
      create: {
        title: 'Створити кластер Ceph',
        info: 'Створюючи новий кластер Ceph, слід вибрати перший вузол, на якому буде встановлено ролі MON і MGR. Крім того, треба вказати, яку підмережу використовувати для трафіку Ceph: підмережа public обслуговує загальний мережевий трафік, а підмережа cluster — внутрішні репліки між OSD; різні підмережі не обов’язкові.',
        controlNode: 'Вузол керування',
        controlNodeHint: 'Вузол-учасник, де народжуються перші MON + MGR.',
        publicSubnet: 'Підмережа public',
        publicSubnetHint: 'Підмережа, зареєстрована в IPAM, — public_network Ceph. Незмінна після створення.',
        clusterSubnet: 'Підмережа cluster',
        clusterSubnetHint: 'Підмережа, зареєстрована в IPAM, — cluster_network Ceph (реплікація/backfill).',
        noSubnets: 'Немає жодної зареєстрованої підмережі — спершу створіть їх в IPAM',
        sameSubnet: 'Та сама підмережа для трафіку public і cluster',
        sameSubnetHint: 'Позначено = мережа cluster (реплікація/backfill) збігається з public. Не позначено = виберіть її підмережу І адресу вузла керування всередині неї.',
        controlAddress: 'Адреса вузла керування',
        controlAddressHint: 'Адреса, яку IPAM знає за цим вузлом усередині підмережі public.',
        controlClusterAddress: 'Адреса вузла керування в мережі cluster',
        controlClusterAddressHint: 'Адреса, яку IPAM знає за цим вузлом усередині підмережі cluster.',
        noAddresses: 'IPAM не знає адрес цього вузла всередині вибраної підмережі',
        started: 'Кластер створено — бутстрап триває як макрозавдання; фаза оновлюється сама',
        error: 'Кластер відхилено'
      },
      detail: {
        actions: 'Доступні дії',
        tabOverview: 'Огляд',
        tabManagementNodes: 'MON і MGR',
        tabDisks: 'OSD',
        tabPools: 'Пули',
        tabObjects: 'Об’єкти',
        tabCrush: 'Карта CRUSH',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Розширені',
        phase: 'Фаза',
        checksTitle: 'Активні перевірки справності',
        noChecks: 'Немає активних перевірок справності',
        checkMuted: 'приглушено',
        summaryPools: 'Пули',
        summaryFilesystems: 'Файлові системи',
        nodesCard: 'Вузли',
        monHint: 'З кожним MON поруч працює MGR. Три MON — рекомендований кворум; лабораторний кластер стартує з одним. OSD та MDS живуть у своїх вкладках.',
        monHintSplit: 'На цьому кластері MON і MGR роз’єднані (Розширені): кожна роль має власне членство на кожному вузлі. Три MON — рекомендований кворум; має існувати щонайменше один MGR.',
        noMons: 'Не оголошено жодного монітора',
        addNode: 'Додати вузол',
        removeNode: 'Вилучити вузол',
        removeNodeFrom: 'Вилучити вузол {node} (його MON і розміщений поруч MGR)',
        roleMon: 'Роль MON',
        roleMgr: 'Роль MGR',
        roleNa: 'N/A',
        roleNotObserved: 'ще не спостерігалася',
        monInQuorum: 'у кворумі',
        monOutQuorum: 'поза кворумом',
        mgrActive: 'активний',
        mgrStandby: 'у резерві',
        addRoleMon: 'Додати роль MON',
        removeRoleMon: 'Вилучити роль MON',
        addRoleMgr: 'Додати роль MGR',
        removeRoleMgr: 'Вилучити роль MGR',
        restartMon: 'Перезапустити службу MON',
        restartMgr: 'Перезапустити службу MGR',
        addMon: 'Додати MON',
        removeMon: 'Вилучити MON',
        removeMonFrom: 'Вилучити роль MON з вузла {node}',
        addMgr: 'Додати MGR',
        removeMgr: 'Вилучити MGR',
        removeMgrFrom: 'Вилучити роль MGR з вузла {node}',
        addMds: 'Додати MDS',
        removeMds: 'Вилучити MDS',
        removeMdsFrom: 'Вилучити роль MDS з вузла {node}',
        mdsSection: 'Сервери метаданих (MDS)',
        noMds: 'Не оголошено жодного MDS — файлова система спершу вимагає його',
        mdsHint: 'Членство MDS від першого дня власне: кластер без CephFS не оголошує жодного, а один активний плюс один у резерві добре обслуговують файлову систему. Ceph сам обирає активних і резервних серед оголошених демонів.',
        mdsActiveFor: 'активний — {fs}',
        mdsNotObserved: 'ще не спостерігався',
        lastMdsGuard: 'Останній MDS не можна вилучити, доки існує файлова система — спершу вилучіть файлові системи',
        lastMonGuard: 'Останній MON вилучити не можна — знищення кластера є єдиним виходом',
        lastMgrGuard: 'Останній MGR вилучити не можна — керований кластер ніколи не працює без менеджера',
        registerDevice: 'Додати OSD',
        unregisterDevice: 'Зняти з реєстрації',
        activeDeviceGuard: 'Активний OSD — виходить через життєвий цикл OSD, а не з реєстру',
        colNode: 'Вузол',
        devicePhase: { registered: 'Зареєстровано', active: 'Активний' },
        health: 'Справність',
        state: 'Стан',
        fsid: 'fsid',
        fsidPending: 'відсутній — повторіть бутстрап',
        version: 'Версія Ceph',
        publicNetwork: 'Мережа public',
        clusterNetwork: 'Мережа cluster',
        clusterNetworkCollapsed: '= public',
        noActions: 'У цій фазі немає доступних дій',
        destroyedNote: 'Кластер знищено — рядок незабаром зникне автоматично'
      },
      overview: {
        services: 'Служби',
        ok: 'у нормі',
        warning: 'попередження',
        down: 'не працюють',
        pgTitle: 'Стани PG',
        pgTotal: 'усього {n} PG',
        capacityTitle: 'Простір',
        ioTitle: 'Поточний I/O',
        ioReadBw: 'Пропускна здатність читання',
        ioWriteBw: 'Пропускна здатність запису',
        ioReadIops: 'IOPS читання',
        ioWriteIops: 'IOPS запису',
        notObserved: 'ще не спостерігалося'
      },
      osd: {
        colId: 'ID',
        colClass: 'Клас пристрою',
        colState: 'Стан',
        colSize: 'Розмір',
        colPgs: 'PG',
        empty: 'Немає жодного OSD — додайте його з оголошеного диска даних',
        markIn: 'Позначити IN',
        markOut: 'Позначити OUT',
        scrub: 'Виконати scrub',
        deepScrub: 'Виконати глибокий scrub',
        restart: 'Перезапустити службу',
        details: 'Деталі',
        actionGuard: 'Лише на активному OSD розгорнутого кластера',
        inTitle: 'Позначити OSD IN',
        inBody: 'osd.{id} повертається в розподіл даних (ceph osd in): Ceph перебалансовує дані на нього.',
        outTitle: 'Позначити OSD OUT',
        outBody: 'osd.{id} виходить із розподілу даних (ceph osd out): його дані перебалансовуються деінде, а надлишковість ЗНИЖЕНА, доки триває backfill. Оборотно будь-якої миті дією «Позначити IN».',
        scrubTitle: 'Запланувати scrub',
        scrubBody: 'Планується scrub osd.{id}: mon ставить його в чергу, а стани PG наступних обходів розкажуть про результат.',
        deepScrubTitle: 'Запланувати глибокий scrub',
        deepScrubBody: 'Планується глибокий scrub osd.{id}: варіант із перевіркою байтів — важчий для I/O, механіка та сама.',
        restartTitle: 'Перезапустити службу OSD',
        restartBody: 'osd.{id} зупиняється й перезапускається через нагляд воркера на своєму вузлі.',
        started: 'Дію запущено — спостереження оновлюється саме',
        error: 'Дію над OSD відхилено'
      },
      osdDetail: {
        title: 'Деталі OSD',
        tabGeneral: 'Загальне',
        tabNetwork: 'Мережа',
        tabDevices: 'Пристрої',
        version: 'Версія',
        hostname: 'Ім’я хоста',
        dataPath: 'Шлях до даних OSD',
        objectStore: 'Сховище об’єктів OSD',
        encrypted: 'Зашифровано',
        yes: 'Так',
        no: 'Ні',
        memory: 'Використання пам’яті (PSS)',
        pid: 'Ідентифікатор процесу (PID)',
        front: 'Адреса front (клієнти й монітори)',
        hbFront: 'Адреса heartbeat front',
        back: 'Адреса back (OSD)',
        hbBack: 'Адреса heartbeat back',
        colDevice: 'Пристрій',
        colType: 'Тип',
        colPhysical: 'Фізичний пристрій',
        colSize: 'Розмір',
        volumeTitle: 'Деталі тому',
        creationTime: 'Дата створення',
        lvName: 'LV Name',
        lvPath: 'LV Path',
        lvUuid: 'LV UUID',
        vgName: 'VG Name',
        noDevices: 'Для цього OSD не спостережено жодного пристрою'
      },
      restart: {
        title: 'Перезапустити службу',
        monBody: 'Демон MON на вузлі {node} зупиняється й перезапускається через нагляд воркера.',
        mgrBody: 'Демон MGR на вузлі {node} зупиняється й перезапускається через нагляд воркера.',
        started: 'Перезапуск розпочато — спостереження оновлюється саме',
        error: 'Перезапуск відхилено'
      },
      encryptionMode: {
        alwaysOn: 'Завжди увімкнене (dmcrypt)',
        alwaysOff: 'Завжди вимкнене',
        perOsd: 'Вибір для кожного OSD',
        section: 'Шифрування OSD у стані спокою',
        title: 'Змінити режим шифрування OSD',
        hint: 'Як готуються НОВІ OSD. Наявні OSD зберігають свій стан на кожному диску: щоб змінити його, OSD вилучають і створюють наново.',
        body: 'Режим стає "{mode}" і діє ЛИШЕ для НОВИХ OSD: кожен наявний OSD зберігає свій поточний стан шифрування.',
        apply: 'Змінити режим',
        error: 'Зміну режиму відхилено'
      },
      pin: {
        address: 'Адреса public (необов’язкове закріплення)',
        clusterAddress: 'Адреса cluster (необов’язкове закріплення)',
        autoPlaceholder: 'автоматично в підмережі {cidr}',
        hint: 'Адресація для кожного демона: порожньо = Ceph сам чіпляється всередині оголошеної мережі; заповнено = цей екземпляр закріплюється за адресою у своєму розділі конфігурації.'
      },
      addMon: {
        title: 'Додати вузол',
        node: 'Вузол',
        address: 'Адреса public',
        addressHint: 'Адреси вузла, які IPAM знає всередині підмережі public — автоматично, коли наявне оголошення вже покриває вузол.',
        clusterAddress: 'Адреса cluster',
        clusterAddressHint: 'Обов’язково: підмережа cluster окрема, і вузол у ній ще не оголошено.',
        noAddresses: 'IPAM не знає адрес цього вузла всередині підмережі',
        error: 'Додавання mon відхилено'
      },
      removeMon: {
        title: 'Вилучити MON',
        body: 'MON і розміщений поруч із ним MGR залишають вузол {node}. На розгорнутому кластері демони зупиняються й вилучаються з кворуму.',
        error: 'Вилучення MON відхилено'
      },
      addMgr: {
        title: 'Додати MGR',
        node: 'Вузол',
        hint: 'Розширені (роз’єднані MON/MGR): окремий менеджер народжується на вибраному вузлі-учаснику завданням, прив’язаним до вузла. Вибори active/standby у Ceph самі визначають активний MGR.',
        error: 'Додавання MGR відхилено'
      },
      removeMgr: {
        title: 'Вилучити MGR',
        body: 'Окремий MGR залишає вузол {node}. На розгорнутому кластері демон зупиняється, а його стан вилучається; MON цього вузла (якщо він є) лишається недоторканим.',
        error: 'Вилучення MGR відхилено'
      },
      addMds: {
        title: 'Додати MDS',
        node: 'Вузол',
        hint: 'Сервер метаданих CephFS: народжується на вибраному вузлі-учаснику завданням, прив’язаним до вузла, під наглядом воркера, як MON і MGR. Ceph сам обирає активних і резервних — один активний плюс один у резерві добре обслуговують файлову систему.',
        error: 'Додавання MDS відхилено'
      },
      removeMds: {
        title: 'Вилучити MDS',
        body: 'MDS залишає вузол {node}. На розгорнутому кластері демон зупиняється, а його стан вилучається; API відмовляє у вилученні останнього MDS, доки він потрібен файловій системі.',
        error: 'Вилучення MDS відхилено'
      },
      split: {
        title: 'Роз’єднані MON/MGR',
        label: 'Дозволити MON і MGR на роз’єднаних вузлах',
        hint: 'Вимкнено (типово) = ратифікований стандарт: з кожним MON поруч працює MGR, одне-єдине членство. Увімкнено = членство MGR стає власним і керується діями «Додати/Вилучити MGR» у вкладці вузлів керування.',
        enable: 'Увімкнути',
        disable: 'Вимкнути',
        enableBody: 'Членство MGR стає незалежним від MON і ініціалізується з поточного спільного розміщення. Дії «Додати/Вилучити MGR» вмикаються у вкладці вузлів керування. Це послаблює типову поведінку платформи — лишайте його, лише якщо знаєте, навіщо воно вам.',
        disableBody: 'Повернення до стандартного спільного розміщення: один MGR з кожним MON, одне-єдине членство. Дозволено, лише якщо членство MGR уже збігається з MON — спершу вирівняйте його діями «Додати/Вилучити MGR», інакше API відмовить.',
        error: 'Зміну відхилено'
      },
      rawEditor: {
        title: 'Сирий редактор CRUSH',
        label: 'Показувати сирий редактор карти CRUSH у вкладці CRUSH',
        hint: 'Вимкнено (типово) = стандартним інструментом є керована поверхня правил. Увімкнено = вкладка CRUSH показує ще й декомпільовану карту CRUSH як редагований текст. Збереження завжди вимагає sudo та назви кластера як підтвердження і проходить через compile + test від crushtool, ПЕРШ НІЖ дістатися кластера.'
      },
      osdFlags: {
        section: 'Глобальні прапорці OSD',
        title: 'Перевизначення прапорців OSD',
        notObserved: 'ще не спостерігалися',
        standardFlowsHint: 'Стандартні потоки платформи керують цими прапорцями самі у звичайних випадках (обслуговування вузла ставить точковий noout, заміна диска йде через життєвий цикл OSD). Цей розділ — ручне перевизначення для оператора, який знає, що робить.',
        notDeployedGuard: 'Прапорці OSD існують лише на розгорнутому кластері',
        set: 'Встановити прапорець',
        unset: 'Зняти прапорець',
        setBody: 'Глобальний прапорець {flag} буде ВСТАНОВЛЕНО в osdmap. Він лишається, доки його явно не знімуть — забутий прапорець погіршує самовідновлення кластера.',
        unsetBody: 'Глобальний прапорець {flag} буде ЗНЯТО з osdmap.',
        error: 'Зміну прапорця відхилено',
        flag: {
          noout: 'Жоден OSD не позначається out у розподілі даних — жодного перебалансування при втраті демона',
          norebalance: 'Перебалансування даних призупинено',
          nobackfill: 'Backfill призупинено',
          norecover: 'Відновлення призупинено',
          pause: 'УВЕСЬ клієнтський I/O на паузі (читання і запис)',
          noin: 'OSD, які запускаються, не позначаються in автоматично',
          nodown: 'Недосяжні OSD не позначаються down — маскує справжні збої'
        }
      },
      pools: {
        section: 'Пули',
        create: 'Створити пул',
        createGuard: 'Пули існують лише на розгорнутому кластері',
        notObserved: 'Немає спостережень пулів — сюди звітує обхід mon',
        empty: 'На кластері немає жодного пулу',
        colName: 'Назва',
        colReplication: 'Size / min size',
        colPgNum: 'PG',
        colApplication: 'Застосунок',
        colRule: 'Правило CRUSH',
        colUsage: 'Використання',
        observedAtLabel: 'Спостережено',
        objects: '{n} об’єктів',
        inUseBy: 'використовується {name}',
        internalGuard: 'Внутрішній пул Ceph — платформа ніколи його не видаляє',
        delete: 'Видалити пул',
        deleteGuard: 'Споживається сховищем {name} — спершу видаліть сховище',
        hint: 'Лише репліковані пули (erasure coding поза межами v1). Реплікація живе в Ceph: ця таблиця — істина, спостережена обходом mon.',
        createTitle: 'Створити пул',
        createHint: 'Пул народжується на кластері з потрібною реплікацією та ввімкненим застосунком rbd — роботу виконує завдання на вузлі MON. Увімкніть «Запропонувати як сховище», щоб спожити його одразу тим самим жестом.',
        name: 'Назва пулу',
        nameHint: 'Безпечна для DNS (малі літери, цифри, дефіси).',
        size: 'Репліки (size)',
        sizeHint: 'Копії кожного об’єкта. Типово 3.',
        minSize: 'Мінімум реплік (min_size)',
        minSizeHint: 'Мінімум копій для обслуговування I/O — стежить за size − 1, доки ви цього не змінили.',
        createError: 'Створення пулу відхилено',
        deleteTitle: 'Видалити пул',
        deleteBody: 'Пул {pool} і КОЖЕН об’єкт усередині нього знищуються безповоротно. Введіть назву пулу для підтвердження.',
        confirmLabel: 'Назва пулу',
        confirmHint: 'Введіть назву пулу для підтвердження',
        deleteError: 'Видалення пулу відхилено',
        detailTitle: 'Деталі пулу',
        autoscaler: 'Автомасштабування PG',
        autoscalerOn: 'Увімкнено',
        autoscalerOff: 'Вимкнено',
        autoscalerWarn: 'Сповіщення',
        pgNumLabel: 'Кількість PG',
        pgNumCaption: 'Спостережено: автомасштабування може змінити це самостійно — тут ви записуєте побажання.',
        storage: 'Пов’язане сховище TVirt',
        addAsStorage: 'Додати як сховище TVirt',
        ruleSudoHint: 'Зміна правила CRUSH вимагає пароля оператора.',
        updateError: 'Зміну пулу відхилено',
        updated: 'Зміну пулу запущено — спостереження оновлюється саме'
      },
      crush: {
        section: 'Правила CRUSH',
        notObserved: 'Спостережень CRUSH ще немає — сюди звітує обхід mon',
        empty: 'На кластері не спостережено жодного правила',
        hint: 'Правило вирішує, ДЕ опиняються копії кожного об’єкта — його домен відмови є одиницею, яка може вийти з ладу без утрати даних. Пули вказують на правило; вбудоване replicated_rule (одна репліка на сервер) є типовим від народження.',
        create: 'Створити правило',
        createGuard: 'Правила CRUSH існують лише на розгорнутому кластері',
        createTitle: 'Створити правило CRUSH',
        createHint: 'Правило = вибір домену відмови. Правило народжується реплікованим на типовому корені — роботу виконує завдання на вузлі MON; пули прив’яжете згодом у вкладці «Пули».',
        createError: 'Створення правила відхилено',
        name: 'Назва правила',
        nameHint: 'Безпечна для DNS (малі літери, цифри, дефіси).',
        domain: 'Домен відмови',
        domainChoice: {
          osd: 'Кожна репліка на іншому OSD',
          host: 'Кожна репліка на іншому сервері',
          rack: 'Кожна репліка в іншій стійці'
        },
        domainCustom: 'Власний (кроки, написані вручну)',
        domainOther: 'Кожна репліка в іншому {type}',
        rackGuardHint: 'У спостереженій ієрархії немає жодного бакета стійки: правило все одно можна створити, але жоден пул не зможе на нього вказувати, доки стійку не оголошено в розміщенні серверів-учасників (налаштування вузла) — завдання вирівнювання побудує бакет, і прив’язка відкриється сама.',
        treeTitle: 'Спостережена ієрархія',
        treeNotObserved: 'Спостережень ієрархії немає — сюди звітує обхід mon',
        treeOsds: '{n} OSD',
        treeHint: 'Карта CRUSH такою, якою її бачить кластер: корінь → оголошені рівні → сервери (host) → OSD. Топологія стежить за оголошеним розміщенням кожного сервера (налаштування вузла) — зміна розміщення вирівнює її через завдання.',
        unplacedWarning: 'Учасники без оголошеного розміщення: {nodes} — їхні хости лишаються прямо під коренем, поза оголошеною топологією. Оголосіть розміщення в налаштуваннях вузла (це попередження, ніколи не блокування).',
        colName: 'Назва',
        colDomain: 'Домен відмови',
        colPools: 'Пули',
        builtinChip: 'вбудоване',
        builtinGuard: 'Типове правило кластера — платформа ніколи його не видаляє',
        detailAction: 'Деталі правила',
        detailType: 'Тип',
        backToRules: 'Правила',
        ruleNotObserved: 'Спостережений список правил не називає цього правила',
        noPools: 'Жоден пул не спирається на це правило',
        delete: 'Видалити правило',
        deleteTitle: 'Видалити правило CRUSH',
        deleteBody: 'Правило {rule} вилучається з карти CRUSH кластера. Жоден пул не має на нього спиратися. Введіть назву правила для підтвердження.',
        deleteGuard: 'На нього спирається пул {name} — спершу перенаправте пул',
        confirmLabel: 'Назва правила',
        confirmHint: 'Введіть назву правила для підтвердження',
        deleteError: 'Видалення правила відхилено',
        changeRule: 'Змінити правило CRUSH',
        changeRuleTitle: 'Змінити правило CRUSH',
        changeRuleHint: 'Пул починає розміщувати свої об’єкти за вибраним правилом — Ceph переміщує наявні дані, щоб вони йому відповідали (на заповненому пулі далі йде перебалансування).',
        changeRuleError: 'Зміну правила відхилено',
        rule: 'Правило CRUSH',
        rawTitle: 'Сира карта CRUSH (декомпільована)',
        rawWarning: 'НЕБЕЗПЕКА: цей текст — УСЯ політика розміщення кластера. Хибна карта може зламати розміщення всіх пулів разом. Збереження компілює й випробовує карту через crushtool, ПЕРШ НІЖ її ввести, — але й правильна карта може виявитися поганою ідеєю.',
        rawReload: 'Перечитати',
        rawLoading: 'Запит у дорозі — завдання лише для читання декомпілює карту CRUSH…',
        rawSave: 'Зберегти карту CRUSH',
        rawSaveTitle: 'Впровадити карту CRUSH',
        rawSaveBody: 'Змінений текст замінює карту CRUSH УСЬОГО кластера після compile + test від crushtool. Введіть назву кластера для підтвердження.',
        rawConfirmLabel: 'Назва кластера',
        rawConfirmHint: 'Введіть {name} для підтвердження',
        rawError: 'Операція над картою CRUSH не вдалася',
        rawHint: 'Текст має форму crushtool -d. Помилки компіляції та тесту повертаються слово в слово від crushtool — карта не дістанеться кластера, якщо не пройде хоча б один із цих двох бар’єрів.'
      },
      objects: {
        poolsSection: 'Оглядач об’єктів',
        poolsHint: 'Виберіть пул, щоб перелічити його образи RBD. Кожне глибоке читання виконується як завдання лише для читання на вузлі MON — воно не блокує справжніх операцій (і не блокується ними).',
        deployedGuard: 'Запити щодо об’єктів відповідають лише на розгорнутому кластері',
        browse: 'Переглянути об’єкти',
        detailAction: 'Деталі образу',
        backToPools: 'Пули',
        backToImages: 'Образи',
        refresh: 'Оновити',
        loading: 'Запит у дорозі — завдання лише для читання опитує кластер…',
        error: 'Запит не вдався',
        retry: 'Повторити',
        notRbd: 'Пул із застосунком "{app}" — він не містить образів RBD, тут немає чого досліджувати',
        noImages: 'У цьому пулі немає жодного образу RBD',
        colImage: 'Образ',
        colSize: 'Розмір',
        colObjects: 'Об’єкти',
        colSnapshots: 'Знімки',
        imagesHint: 'Диски на сховищі, яке споживає rbd, є образами з назвою свого ID диска. Кількість об’єктів — це виділене (розмір / розмір об’єкта), а реальне використання живе в деталях образу.',
        infoTitle: 'Образ',
        infoSize: 'Віртуальний розмір',
        infoObjects: 'Об’єкти (виділено)',
        infoObjectSize: 'Розмір об’єкта',
        infoPrefix: 'Префікс об’єктів',
        infoFormat: 'Формат',
        infoFeatures: 'Функції',
        usageTitle: 'Реальне використання (rbd du)',
        usageOf: 'з {provisioned} GiB виділених',
        usageHint: 'Тонкий за природою: байти займають лише записані об’єкти.',
        watchersTitle: 'Спостерігачі',
        noWatchers: 'Жодного спостерігача — зараз ніхто не тримає цей образ відкритим',
        snapshotsTitle: 'Знімки RBD',
        noSnapshots: 'На цьому образі немає жодного знімка RBD',
        colSnapshot: 'Знімок',
        colProtected: 'Захищений',
        colTimestamp: 'Створено',
        protected: 'захищений',
        mappingTitle: 'Фізичне відображення (набір OSD)',
        mappingSampled: 'Вибірка з {sampled} об’єктів із {total} — чесне зведення: для великих образів набір збігається до ВСІХ OSD пулу (CRUSH розподіляє об’єкти по всьому пулу).',
        mappingComplete: 'Усі об’єкти відображено ({total} з {total}).',
        objectQueryTitle: 'Відобразити один об’єкт',
        objectName: 'Назва об’єкта',
        objectHint: 'Назви об’єктів RADOS мають вигляд <префікс>.<індекс, 16 hex-цифр> — ceph osd map відповідає групою PG і трійками OSD.',
        mapObject: 'Відобразити',
        primary: 'первинний: osd.{osd}'
      },
      registerDevice: {
        title: 'Зареєструвати пристрій OSD',
        hint: 'На живому кластері реєстрація ще й ГОТУЄ пристрій: він стає OSD BlueStore автоматичним завданням, прив’язаним до вузла (ніколи не порожнім, ратифіковано 2026-07-24). Пристрій належить щонайбільше одному кластеру Ceph в усьому флоті.',
        disk: 'Диск даних',
        diskHint: 'Оголошені диски даних вузла — назва та серійний номер',
        noDeclared: 'На цьому вузлі не оголошено жодного диска даних — спершу позначте їх у локальних налаштуваннях вузла',
        serialHint: 'Серійний номер пристрою — закріплення ідентичності',
        encrypted: 'Шифрувати цей OSD (dmcrypt)',
        encryptedHint: 'Вибір для кожного OSD (режим кластера — «вибір для кожного OSD»): він заморожується на цьому диску під час реєстрації — подальша зміна режиму ніколи його не переписує; це робить рядкова дія «зашифрувати/розшифрувати».',
        error: 'Реєстрацію відхилено'
      },
      unregisterDevice: {
        title: 'Зняти пристрій з реєстрації',
        body: 'Лише реєстр: {name} перестає бути кандидатом на OSD цього кластера. Його байтів ніхто не торкається.',
        error: 'Зняття з реєстрації відхилено'
      },
      deploy: {
        action: 'Повторити розгортання',
        title: 'Повторити бутстрап',
        body: 'Первинний бутстрап стартує наново з поточної конфігурації: mon запускаються, кожен зареєстрований пристрій готується й активується як OSD BlueStore. Операція виконується як макрозавдання — фаза оновлюється сама.',
        started: 'Бутстрап розпочато — триває як макрозавдання; фаза оновлюється сама',
        error: 'Бутстрап відхилено'
      },
      propose: {
        action: 'Запропонувати як сховище',
        title: 'Запропонувати як сховище',
        hintPool: 'Наявний пул {name} стає сховищем TVirt: ідентичність cephx, обмежена цим пулом, потрапляє у сховище ключів, а сховище ceph-rbd народжується готовим. Пропозиція споживає пул — вона ніколи його не створює.',
        hintFs: 'Наявна файлова система {name} стає сховищем TVirt: ідентичність cephx, обмежена цією файловою системою, потрапляє у сховище ключів, а сховище cephfs народжується готовим і змонтованим. Пропозиція споживає файлову систему — вона ніколи її не створює.',
        name: 'Назва сховища',
        nameHint: 'DNS-1123, унікальна в межах скоупа — ідентичність cephx бере назву від неї.',
        path: 'Шлях усередині файлової системи',
        pathHint: 'Абсолютний шлях усередині файлової системи, який монтує сховище — /, якщо сумніваєтеся.',
        alsoPropose: 'Одразу запропонувати як сховище',
        alsoProposePoolHint: 'Після створення той самий жест пропонує щойно народжений пул як сховище ceph-rbd — два явні виклики, один діалог.',
        alsoProposeFsHint: 'Після створення той самий жест пропонує щойно народжену файлову систему як сховище cephfs — два явні виклики, один діалог.',
        guard: 'Запропонувати як сховище — лише на кластері в нормі',
        started: 'Пропозицію прийнято — сховище матеріалізується; знайдете його в розділі «Сховище»',
        submit: 'Створити сховище',
        error: 'Пропозицію відхилено'
      },
      fs: {
        section: 'Файлові системи',
        create: 'Створити файлову систему',
        createGuard: 'Файлові системи існують лише на розгорнутому кластері',
        mdsFirstGuard: 'Спершу додайте MDS — файлова система без сервера метаданих народжується непридатною',
        notObserved: 'Немає спостережень файлових систем — сюди звітує обхід MON',
        empty: 'На кластері немає жодної файлової системи',
        colName: 'Назва',
        colPools: 'Пули',
        colMds: 'MDS',
        noActiveMds: 'немає активного MDS',
        delete: 'Вилучити файлову систему',
        deleteGuard: 'Споживається сховищем {name} — спершу видаліть сховище',
        hint: 'Файлова система володіє своїми пулами даних і метаданих (cephfs.<назва>.data / .meta): вони народжуються з нею й помирають із нею — removeFs, і ніколи не видалення пулу вручну. Ця таблиця — істина, спостережена обходом MON.',
        createTitle: 'Створити файлову систему',
        createHint: 'Файлова система народжується на кластері зі своїми двома пулами (застосунок cephfs) і обслуговується оголошеними MDS — роботу виконує завдання на вузлі MON. Увімкніть «Запропонувати як сховище», щоб спожити її одразу тим самим жестом.',
        name: 'Назва файлової системи',
        nameHint: 'Безпечна для DNS (малі літери, цифри, дефіси).',
        sizeHint: 'Репліки ОБОХ народжуваних пулів. Типово 3.',
        createError: 'Створення файлової системи відхилено',
        deleteTitle: 'Вилучити файлову систему',
        deleteBody: 'Файлова система {fs} і КОЖЕН файл усередині неї знищуються безповоротно — її пули даних і метаданих помирають разом із нею. Введіть назву файлової системи для підтвердження.',
        confirmLabel: 'Назва файлової системи',
        confirmHint: 'Введіть назву файлової системи для підтвердження',
        deleteError: 'Вилучення файлової системи відхилено'
      },
      destroy: {
        action: 'Знищити',
        retryAction: 'Повторити знищення',
        retryGuard: 'Знищення триває — повтор стосується невдалого знищення (інакше оренда відмовляє)',
        title: 'Знищити кластер',
        body: 'Розгорнуту фабрику буде демонтовано: кожен демон цього кластера зупиняється, а його системний стан і ключі у сховищі ключів звільняються. Після успішного знищення кластер вилучається автоматично.',
        confirmLabel: 'Назва кластера',
        confirmHint: 'Введіть назву кластера для підтвердження',
        wipe: 'Стерти зареєстровані пристрої',
        wipeHint: 'Позначено: сигнатури кожного зареєстрованого пристрою стираються — дані на них знищуються. Не позначено: байти лишаються недоторканими, а пристрої повертаються у стан зареєстрованих.',
        guard: 'Знищити — нічого не розгорнуто',
        started: 'Знищення розпочато — триває як макрозавдання; фаза оновлюється сама',
        error: 'Знищення відхилено'
      },
      delete: {
        guard: 'Видалити — лише нерозгорнуту конфігурацію (спершу знищіть)',
        title: 'Видалити {name}?',
        body: 'Конфігурація та її реєстр пристроїв вилучаються. Дозволено, лише доки нічого не розгорнуто.',
        error: 'Видалення відхилено'
      }
    }
  }
}
